var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoguito(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 179.38 340.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #5ec3b2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.46,322.13c0,6.27-2.07,11.07-6.19,14.42-4.13,2.93-8.67,4.38-13.62,4.38s-9.29-1.46-13-4.38c-3.72-3.35-5.58-8.15-5.58-14.42v-66.01h38.39v66.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.07,
    y: 147.07,
    width: 38.39,
    height: 96.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.41,0c3.3,0,5.98.21,8.05.63,2.07.42,4.13,1.67,6.19,3.76,4.54,2.92,6.81,7.73,6.81,14.41v116.15h-38.39V18.8c0-6.68,2.07-11.49,6.19-14.41s7.85-4.39,11.15-4.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.5,72.61c-4.05,2.23-14.09,13.54-15.7,18.98,7.07,1.48,14.35,6.99,20.99,10.06,7.39,3.41,17.65,5.54,25.71,4.76,16.6-1.59,30.54-11.58,39.74-27.92,2.21-3.92,4.07-8,6.21-11.96.72-1.35,3.76-8.51,2.73-10.36-1.47-2.63-13.14,1.3-14.89,2.15-13.16,6.37-25.72,6.11-39.5,6.77-8.62.42-17.33,3.16-25.27,7.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.63,167.34c3.4,2.96,10.7,15.9,11.17,21.46-6.96,0-14.91,3.85-21.76,5.46-7.64,1.8-17.75,1.78-25.21-.59-15.38-4.88-26.62-17.31-32.15-34.92-1.33-4.23-2.3-8.53-3.56-12.78-.43-1.45-1.91-8.96-.57-10.53,1.9-2.24,12.16,3.9,13.65,5.08,11.2,8.8,23.12,11.06,36,14.48,8.06,2.14,15.76,6.54,22.43,12.34Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoguito);
export default __webpack_public_path__ + "static/media/loguito.40e7d8a356252b2a00d0cb08cdb02c65.svg";
export { ForwardRef as ReactComponent };